//export const BASE_URL = 'http://localhost:8080/consulta-nomina-dif-backend';
//export const BASE_URL = 'https://quadrumdesarrollo.com.mx/consulta-nomina-dif-backend/';
export const BASE_URL = 'https://q-nomina.com.mx/consulta-nomina-dif-backend/';
export const TOKEN_QUADRUM_DIF="TokenQDIF";
export const USUARIO_KEY="UserQuadrumDif"
export const BEARER="Bearer "